import { PcbNodeTypes, PrimitiveRole, } from "@buildwithflux/models";
import { vec3 } from "../../../common";
/**
 * Given a 3D position, computes the projected 2D position on a container, useful for determining events collisions and such
 * @param position The 3D position to transform
 * @param container From `containerMap` from the PcbShapesStore
 * @returns The transformed 2D position
 */
export function getLocalPositionForContainer(position, container) {
    return vec3.applyMatrix4(position, container.transformInverse);
}
export function getWorldPositionFromContainer(position, container) {
    return vec3.applyMatrix4({ x: position.x, y: position.y, z: 0 }, container.transform);
}
/**
 * Returns an iterator that yields all pads in the PCB layout that are descendants of the given uids. Important note: this
 * is intended to be used for batched pads only. If batched pads are not enabled, this function acts as a noop.
 */
export function* iterateBatchedAndBatchedDescendants(nodes, uids, flags) {
    const visited = new Set();
    function isNodeBatched(node) {
        // Temporary filter for pads - if this function is used for other node types
        // this will need to be updated accordingly
        return (node.type === PcbNodeTypes.pad ||
            node.type === PcbNodeTypes.circle ||
            (node.type === PcbNodeTypes.rectangle && flags.enablePcbBatchedSilkRectangle) ||
            (node.type === PcbNodeTypes.line && flags.enablePcbBatchedSilkLine));
    }
    function* iterateDescendants(uid) {
        if (visited.has(uid)) {
            // This case can arise when one draggable subject is the descendant of
            // another. In that scenario, we want to avoid yielding the same node
            // multiple times
            return;
        }
        visited.add(uid);
        const node = nodes[uid];
        if (!node) {
            return;
        }
        if (isNodeBatched(node)) {
            yield node;
        }
        for (const childUid of node.childUids) {
            yield* iterateDescendants(childUid);
        }
    }
    for (const uid of uids) {
        yield* iterateDescendants(uid);
    }
}
// Note: this is a hack which is due to PrimitiveStore not defining the intrinsic position of
// a node. Instead, it defines a collection of possible positions that a node exists at, per
// the collection of primitives that are related to that node. This attempts to resolve a position
// for a node based on the assumptions that; 1. copper is colocated across all layers and 2. copper
// is the center of gravity for the node.
// If this criteria is not met, this will return the last primitive that is found in the quad tree node.
export function guessPrimaryPrimitiveForNodeTransform(quadTreeNode) {
    let guess;
    if (quadTreeNode) {
        for (const primitive of quadTreeNode.primitives) {
            guess = primitive;
            if (guess.role === PrimitiveRole.copper) {
                break;
            }
        }
    }
    return guess;
}
//# sourceMappingURL=utils.js.map